import useAxiosClient from "../../../../hooks/useAxiosClient";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../../../store";
import { toast } from "react-toastify";
import { setBenPayoutOtp, setRefId, setRefreshGetAll, setTableClick } from "../bloc/beneficiariesSlice";

const useBeneficiaryActById = () => {
  const { handlePutCall } = useAxiosClient();

  const dispatch = useDispatch();

  const { adminId, selectedBeneficiary, payoutClick, currentSteps, roleType } =
    useSelector((state: TRootState) => ({
      adminId: state.auth.userInfo.adminId,
      selectedBeneficiary: state.beneficiary.selectedBeneficiary,
      payoutClick: state.beneficiary.payoutClick,
      currentSteps: state.beneficiary.currentSteps,
      roleType: state.auth.userInfo.roleType
    }));
  
  const onClickSubmitStatusChange = () => {
    const newStatus = selectedBeneficiary?.status === 1 ? 0 : 1;
    handlePutCall({
      URL: `admin/trade-platform/traders/accounts/adminId/${adminId}/id/${selectedBeneficiary?.id}?accStatus=${newStatus}`,
    })
      .then(({ data, status }) => {
          toast.success(status.description);
          dispatch(setBenPayoutOtp(0));
          dispatch(setRefId(''));
          dispatch(setRefreshGetAll());
          dispatch(setTableClick(false));
      })
      .catch((err: any) => {})
  };

  return {
    selectedBeneficiary,
    payoutClick,
    currentSteps,
    onClickSubmitStatusChange,
    roleType
  };
};
export default useBeneficiaryActById;
